import { IViewPaymentLink } from "../../../interfaces-and-types";
import { HostedPaymentLinks } from "../../HostedPaymentLinks";
import { InlinePaymentLinkPagePreview } from "../InlinePaymentLinkPagePreview";
import { IPaymentLinkPreviewProps } from "./PaymentLinkPreview";

export const View = (
  props: IPaymentLinkPreviewProps & {
    paymentLinkToPreviewWithMappedProducts: IViewPaymentLink;
  }
) => {
  return (
    <div className="payment-link-preview--container">
      <div className="flex-container payment-link-preview--header align-items--center">
        <div className="window-control--icon" />
        <div className="window-control--icon" />
        <div className="window-control--icon mr-5" />

        <div className="payment-link-preview--url flex-box flex-container justify-content--center">
          <span className="switchapp-url switchapp-small">
            pay.switchappgo.com
          </span>
        </div>
      </div>

      <div className="payment-link-preview--body flex-container">
        <InlinePaymentLinkPagePreview
          paymentLinkToPreview={props.paymentLinkToPreview}
          productsInPaymentLink={props.productsInPaymentLink}
        />

        {/* <HostedPaymentLinks
          isPreviewMode={true}
          paymentLinkToPreview={props.paymentLinkToPreviewWithMappedProducts}
        /> */}
      </div>

      <div className="payment-link-preview--footer"></div>
    </div>
  );
};
